import { render, staticRenderFns } from "./front-mobile-table.vue?vue&type=template&id=44ca30f7"
import script from "./front-mobile-table.vue?vue&type=script&lang=js"
export * from "./front-mobile-table.vue?vue&type=script&lang=js"
import style0 from "./front-mobile-table.vue?vue&type=style&index=0&id=44ca30f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports